<!-- WAIT Section -->
<div class="px-4 pt-8 pb-6">
  <div class="w-[750px] max-w-[100%] mx-auto flex flex-col sm:flex-row items-start gap-6" [ngClass]="{'color_background' : isFull }">
    <!-- Left Section: Icon and Headline -->
    <div class="flex flex-row items-center gap-4 w-full sm:w-auto" [ngClass]="{'color_background' : isFull }">
      <div class="flex items-center justify-center flex-shrink-0">
        <img class="h-auto w-auto" src="{{ iconWait }}" alt="">
      </div>
      <div class="flex flex-col">
        <h2 class="text-2xl sm:text-[42px] font-bold text-marty-green uppercase mb-4 oswald leading-tight sm:leading-[1.2]" [innerHTML]="title"></h2>
        <!-- Description shows under headline on desktop only -->
        <p class="hidden sm:block" [innerHTML]="description"></p>
      </div>
    </div>
    
    <!-- Right Section: Body Text (mobile only) -->
    <div class="sm:hidden flex-1 w-full">
      <p [innerHTML]="description"></p>
    </div>
  </div>
</div>